<template>
  <div class="certification">
    <div class="tabs">
      <p :class="{active: tabsIndex === 1}" @click="switchTab(1)">认证管理</p>
      <p :class="{active: tabsIndex === 2}" @click="switchTab(2)">小程序比对记录</p>
      <p :class="{active: tabsIndex === 3}" @click="switchTab(3)">一体机比对记录</p>
    </div>
    <certification-manage v-if="tabsIndex === 1"></certification-manage>
    <certification-mini-program-log v-else-if="tabsIndex === 2"></certification-mini-program-log>
    <certification-aio-log v-else-if="tabsIndex === 3"></certification-aio-log>
  </div>
</template>

<script>
  import CertificationManage from '@/views/CertificationManage.vue';
  import CertificationMiniProgramLog from '@/views/CertificationMiniProgramLog.vue';
  import CertificationAioLog from '@/views/CertificationAioLog.vue';

  export default {
    name: 'IdentificationLog',
    data() {
      return {
        tabsIndex: null
      }
    },
    mounted() {
      this.switchTab(1);
    },
    components: {
      CertificationManage,
      CertificationMiniProgramLog,
      CertificationAioLog
    },
    methods: {
      switchTab(index) {
        this.tabsIndex = index;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .certification {
    margin-top: 42px;
    position: relative;
    &.blank-v {
      padding-bottom: 0;
    }
    .tabs {
      display: flex;
      height: 40px; 
      position: absolute;
      top: -42px;
      left: 0;
      p {
        padding: 0 20px;
        cursor: pointer;
        min-width: 60px;
        height: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 2px solid transparent;
        transition: all @time;
        background-color: rgba(255, 255, 255, .5);
        &.active {
          background-color: rgba(255, 255, 255, 1);
          border-top: 2px solid @color-primary;
        }
      }
    }
  }
</style>